import { profileState } from "@/atoms/user/profile-state";
import { PayMethod, payMethodDisplayNames } from "@/common/enum/pay-method";
import { Label, Radio } from "flowbite-react";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { TextInputLabel } from "../label/TextInputLabel";
import { useRecoilValue } from "recoil";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { orderService } from "@/services/order-service2";

interface Props {
  paymentType: PayMethod;
  setPaymentType: Dispatch<SetStateAction<PayMethod>>;
  onPayLaterConfirm: (e: boolean) => void;
  children?: any;
}

export const PartnerPaymentTypePanel: React.FC<Props> = ({
  paymentType,
  setPaymentType,
  children,
}) => {
  const profile = useRecoilValue(profileState);
  const paymentOptions = Object.entries(PayMethod);

  const [filteredInvoiceList, setFilteredInvoiceList] = useState<
    OrderDetailDto[]
  >([]);
  useEffect(() => {
    const fetch = async () => {
      const { data, ok } = await orderService.getInvoiceList({
        paymentType: "PAVC",
        paymentStatus: "PENDING",
      });
      if (ok) {
        setFilteredInvoiceList(data);
      }
    };

    fetch();
  }, []);


  return (
    <div className="flex flex-col px-[24px] py-[16px] gap-[20px] bg-primary-white rounded-lg border-[1px] border-semantic-divider">
      <TextInputLabel required>결제수단 선택</TextInputLabel>
      <fieldset className="flex gap-[20px]">
        {paymentOptions.map(([key, value]) => {
          if (
            [
              PayMethod.POINT,
              PayMethod.MOBILE,
              PayMethod.GIFT_CARD,
              // PayMethod.VIRTUAL_ACCOUNT,
            ].includes(value as PayMethod)
          ) {
            return null;
          }
          if (value === PayMethod.PAY_LATER && !profile.canPayLater)
            return null;

          // if (value === PayMethod.VIRTUAL_ACCOUNT && profile.email !== "aqaralife_b2b@aqara.kr") return null

          const disabled =
            value === PayMethod.VIRTUAL_ACCOUNT &&
            filteredInvoiceList.length > 0;

          return (
            <Label
              key={key}
              className="flex items-center gap-[8px] px-[24px] py-[19px] rounded-lg border-[1px] border-semantic-divider w-full max-w-[434px]"
              htmlFor={key}
              onClick={() => {
                if (value === PayMethod.VIRTUAL_ACCOUNT && filteredInvoiceList.length > 0) {
                  alert("먼저 이전 가상계좌 발주 건의 입금을 완료해주세요.");
                  return;
                }
                setPaymentType(value as PayMethod);
              }}
            >
              <Radio
                id={key}
                name="paymentType"
                value={value}
                checked={paymentType === value}
                disabled={disabled}
              />
              <Label htmlFor={key} disabled={disabled}>
                {payMethodDisplayNames[value as PayMethod]}
              </Label>
            </Label>
          );
        })}
      </fieldset>
      {children}
    </div>
  );
};
